import React from 'react';
// import PropTypes from 'prop-types';

const Footer = () => (
  <React.Fragment>
    <span><a href="/" target="_blank" rel="noopener noreferrer"> Avanga2.0</a> &copy; 2020</span>
    <span className="ml-auto"><a href="https://wetelo.com" target="_blank" rel="noopener noreferrer">Wetelo Inc.</a></span>
  </React.Fragment>
);

Footer.propTypes = {
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/footer/Footer.js